import { render, staticRenderFns } from "./proposta.vue?vue&type=template&id=2a9e968e"
import script from "./proposta.vue?vue&type=script&lang=js"
export * from "./proposta.vue?vue&type=script&lang=js"
import style0 from "./proposta.vue?vue&type=style&index=0&id=2a9e968e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports